import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PnrFlightFormComponent } from 'app/components/pnr-flight-form/pnr-flight-form.component';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormGroup, FormsModule } from '@angular/forms';
import { MatButtonModule} from '@angular/material/button';
import { MatCheckboxModule} from '@angular/material/checkbox';
import { MatDividerModule} from '@angular/material/divider';
import { MatFormFieldModule} from '@angular/material/form-field';
import { MatIconModule} from '@angular/material/icon';
import { MatInputModule} from '@angular/material/input';
import { MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {MatProgressBarModule} from '@angular/material/progress-bar';
import {MatCardModule} from '@angular/material/card';
import {MatSnackBarModule} from '@angular/material/snack-bar';
import {MatToolbarModule} from '@angular/material/toolbar'
import { PassengerDigitalTwinComponent } from 'app/components/passenger-digital-twin/passenger-digital-twin.component';
import { OrientationPopupComponent } from 'app/components/passenger-digital-twin/orientation-popup/orientation-popup.component';
import { PassengerVideoViewComponent } from 'app/components/passenger-digital-twin/passenger-video-view/passenger-video-view.component';
import { WebRtcService } from 'app/services/web-rtc.service';
import { HttpClientModule } from '@angular/common/http';
import { ApiService } from 'app/services/api.service';
import { SocketService } from 'app/services/socket.service';
import { PaxGuardGuard } from 'app/pax-guard.guard';
import { AllGatesComponent } from 'app/components/all-gates/all-gates.component';
import { AppComponent } from 'app/app.component';
import { SwiperModule } from 'ngx-swiper-wrapper';
import { DynamicgateComponent } from 'app/components/dynamicgate/dynamicgate.component';
import { NgbAlertModule, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { CountdownModule } from '@ciri/ngx-countdown'
import { KeyboardComponent } from 'app/components/keyboard/keyboard.component';


const appRoutes: Routes = [
  { path: '', component: PnrFlightFormComponent, pathMatch: 'full' },
  // { path: 'pax', component: PassengerDigitalTwinComponent, pathMatch: 'full', canActivate: [PaxGuardGuard] },
  { path: 'pax', component: PassengerDigitalTwinComponent, pathMatch: 'full'},
  {path:'gates', component: AllGatesComponent, pathMatch:'full'},
  // {path:'random', component:DynamicgateComponent, pathMatch:'full'},
  { path: '**', component: PnrFlightFormComponent },
];

@NgModule({
  declarations: [
    PnrFlightFormComponent,
    PassengerDigitalTwinComponent,
    OrientationPopupComponent,
    PassengerVideoViewComponent,
    KeyboardComponent
  ],
  imports: [
    RouterModule.forRoot(appRoutes),
    HttpClientModule,
    BrowserModule,
    BrowserAnimationsModule,
    FormsModule,
    MatInputModule,
    MatFormFieldModule,
    MatIconModule,
    MatButtonModule,
    MatCardModule,
    MatSnackBarModule,
    MatToolbarModule,
    MatCheckboxModule,
    MatDividerModule,
    MatProgressSpinnerModule,
    SwiperModule,
    NgbModule,
    MatProgressBarModule,
    NgbAlertModule,
    CountdownModule,
    // MatDialogModule
  ],
  providers: [
    WebRtcService,
    ApiService,
    SocketService,
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
